import { Component, Input, OnInit } from '@angular/core';
import { WebsiteBuilderItemWelcome } from '../../../../../types/website-builder/items';

@Component({
    selector: 'wb-edit-top-banner',
    templateUrl: './wb-edit-top-banner.component.html',
    styleUrls: [
        '../../website-builder-side-editor.component.scss',
        './wb-edit-top-banner.component.scss'
    ]
})
export class WbEditTopBannerComponent {

    @Input() pageData: WebsiteBuilderItemWelcome;

    constructor() {
    }

}



// WEBPACK FOOTER //
// /app/src/app/views/website-builder/website-builder-side-editor/section/wb-edit-top-banner/wb-edit-top-banner.component.ts